module.exports = __webpack_public_path__ + "img/5.86cc31cd.jpg";